import React from 'react'
import {Table} from 'react-bootstrap';
import Row from './csv-table-row';

const CsvTable = ({data = [], handleListChange}) => {
    return (
        <Table striped bordered condensed hover>
            <thead>
            <tr>
                <th>#</th>
                <th>File name</th>
            </tr>
            </thead>
            <tbody>
                {data.map((value, key) => <Row key={key} filename={value} handleListChange={handleListChange}/>)}
            </tbody>
        </Table>
    )
}

export default CsvTable


// WEBPACK FOOTER //
// ./src/components/admin/data-import/csv-table.jsx